import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "sonner";
import ContactPage from "@/components/ContactPage";
import BlogPage from "@/components/BlogPage";
import PolicyPage from "@/components/PolicyPage";
import Landing from "@/components/Landing";
import Dashboard from "@/components/Dashboard";
import NotFound from "@/components/NotFound";
import SeoCheckPage from "@/components/SeoCheckPage";
import UseCasePage, { UseCasesIndex } from "@/components/UseCasePage";
import AlternativePage from "@/components/AlternativePage";
import IntegrationsPage from "@/components/IntegrationsPage";
import DocsPage, { DocsIndex } from "@/components/DocsPage";
import { getToken } from "@/lib/api";

const UseCaseRoute = () => <UseCasePage slug={useParams().slug} />;
const AlternativeRoute = () => <AlternativePage slug={useParams().slug} />;
const DocRoute = () => <DocsPage slug={useParams().slug} />;

const Protected = ({ children }) => {
  return getToken() ? children : <Navigate to="/" replace />;
};

/**
 * The document title for `/` is baked into the served HTML by
 * `scripts/prerender.mjs`, so there is no effect here setting it at runtime.
 * A client-side title is invisible to a first-wave crawl.
 *
 * Routes that are not prerendered set their own title through `useHeadMeta`.
 */
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/tools/seo-check" element={<SeoCheckPage />} />
          <Route path="/use-cases" element={<UseCasesIndex />} />
          <Route path="/use-cases/:slug" element={<UseCaseRoute />} />
          <Route path="/alternatives/:slug" element={<AlternativeRoute />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/docs" element={<DocsIndex />} />
          <Route path="/docs/:slug" element={<DocRoute />} />
          <Route path="/acceptable-use" element={<PolicyPage title="Acceptable Use Policy" />} />
          <Route path="/privacy" element={<PolicyPage title="Privacy Policy" />} />
          <Route path="/terms" element={<PolicyPage title="Terms of Service" />} />
          <Route path="/cookies" element={<PolicyPage title="Cookie Policy" />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          {/*
            Unknown URLs render a real not-found page. Previously this redirected
            to `/`, which produced soft 404s and hid broken links.
          */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
